export function formatCurrency(value) {
  let num = typeof value === 'string' ? Number(value.replace(/[^\d.-]/g, '')) : value;
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(num || 0);
}